import React from "react";
import CalendarInput from "../../components/Atomos/Inputs/CalendarInput";
import TimeInput from "../../components/Atomos/Inputs/TimeInput";
import { ActionFormData } from "./types";
import { RadioGroup, FormSection } from "./components";
import { EMAIL_ACTION_OPTIONS, TIMEZONE_OPTIONS } from "./dummy_data";

interface ActionCardProps {
  formData: ActionFormData;
  onFormChange: (updates: Partial<ActionFormData>) => void;
}

export default function ActionCard({
  formData,
  onFormChange,
}: ActionCardProps): React.ReactElement {
  const isScheduleEnabled = formData.actionType === "schedule";

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="px-6 lg:px-8 py-5 border-b border-gray-100">
        <h3 className="text-[2rem] font-decimal font-medium leading-none text-Default">
          Step 3: Action
        </h3>
      </div>

      <div className="px-6 lg:px-8 py-6">
        <div className="flex flex-wrap items-stretch gap-6">
          <div className="px-6 py-4">
            <RadioGroup
              title="Email"
              options={EMAIL_ACTION_OPTIONS}
              value={formData.actionType}
              onChange={(actionType) => onFormChange({ actionType })}
              name="actionType"
            />
          </div>

          {isScheduleEnabled && (
            <div className="w-px bg-gray-200 self-stretch" />
          )}

          {isScheduleEnabled && (
            <div className="flex flex-wrap items-stretch gap-6 px-6 py-4 border border-gray-200 rounded-lg flex-1">
            <FormSection title="Scheduled Date / Time">
              <div className="flex items-end gap-3">
                <div className="w-[200px]">
                  <CalendarInput
                    title=""
                    type="single"
                    value={formData.scheduledDate}
                    onChange={(e) => onFormChange({ scheduledDate: e.target?.value || e })}
                    placeholder="MM/DD/YYYY"
                  />
                </div>
                <div className="w-[140px]">
                  <TimeInput
                    title=""
                    value={formData.scheduledTime}
                    onChange={(time) => onFormChange({ scheduledTime: time })}
                    placeholder="00:00 hrs"
                    minuteInterval={15}
                  />
                </div>
              </div>
            </FormSection>
            <div className="w-px bg-gray-200 self-stretch" />

            <RadioGroup
              title="Time Zone"
              options={TIMEZONE_OPTIONS}
              value={formData.timeZone}
              onChange={(timeZone) => onFormChange({ timeZone })}
              name="timeZone"
            />
          </div>
          )}
        </div>
      </div>
    </div>
  );
}